"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const JkcRadio = (props) => {
    const { name, settings, onChangeEvent, columns } = props;
    const radioRef = (0, react_1.useRef)();
    let labelStyle = {
        marginBottom: "0px",
        position: settings.isNormalLabel ? "relative" : "absolute",
    };
    let radioLabelStyle = {
        flexGrow: 1,
        wordBreak: "break-word",
    };
    let inputStyle = {
        width: "100%",
        padding: settings.isNormalLabel ? "0px 7px 0px 7px" : "10px 7px 0px 7px",
        fontSize: "15px",
        border: "1px solid #D3D3D3",
        outline: "none",
        textAlign: "left",
    };
    let radioInputStyle = {
        flexShrink: 0,
        flexGrow: 0,
        width: "27px",
        height: "27px",
        marginRight: "10px",
    };
    let gridStyle = {
        display: "grid",
        gridTemplateColumns: `repeat(${columns}, 1fr)`,
        gap: "10px",
    };
    let flexStyle = {
        display: "flex",
        flexDirection: "row",
        gap: "20px",
        flexWrap: "wrap"
    };
    (0, react_1.useEffect)(() => {
        if (settings.pointerColor) {
            radioRef.current.style.setProperty("--smartjkc-radio-checked-color", settings.pointerColor);
        }
        if (settings.radioCheckedBorderColor) {
            radioRef.current.style.setProperty("--smartjkc-radio-checked-border-color", settings.radioCheckedBorderColor);
        }
        if (settings.radioUncheckedBorderColor) {
            radioRef.current.style.setProperty("--smartjkc-radio-unchecked-border-color", settings.radioUncheckedBorderColor);
        }
        if (settings.radioBorder) {
            radioRef.current.style.setProperty("--smartjkc-radio-border", settings.radioBorder);
        }
        if (settings.radioHeight) {
            radioRef.current.style.setProperty("--smartjkc-radio-height", settings.radioHeight);
        }
        if (settings.radioWidth) {
            radioRef.current.style.setProperty("--smartjkc-radio-width", settings.radioWidth);
        }
    }, []);
    let fieldStyle = {
        position: "relative",
        width: "100%",
        display: settings.fieldTypes == "Grid" ? "flex" : "block",
        borderTop: settings.fieldTypes == "Grid" ? "1px solid #dddddd" : "none",
        borderBottom: settings.fieldTypes == "Grid" ? "1px solid #dddddd" : "none",
        marginTop: "-1px",
    };
    if (settings.fieldTypes == "Grid") {
        fieldStyle.alignItems = "center";
    }
    let fieldLablStyle = {
        width: settings.fieldTypes == "Grid" ? "30%" : "100%",
        padding: settings.fieldTypes == "Grid" ? "10px 10px" : "0px",
    };
    let fieldInputStyle = {
        width: settings.fieldTypes == "Grid" ? "70%" : "100%",
        padding: settings.fieldTypes == "Grid" ? "10px 10px" : "0px",
        borderLeft: settings.fieldTypes == "Grid" ? "1px solid #dddddd" : "none",
        position: "relative",
    };
    if (settings.fieldTypes == "Grid") {
        fieldLablStyle.textAlign = "right";
    }
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ style: fieldStyle, ref: radioRef, className: "component-area-cn" }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ style: fieldLablStyle }, { children: !settings.hideLabel ? ((0, jsx_runtime_1.jsx)("label", Object.assign({ style: Object.assign(Object.assign({}, labelStyle), settings.labelStyle), htmlFor: name }, { children: settings.label ? settings.label : "Label" }))) : null })), (0, jsx_runtime_1.jsx)("div", Object.assign({ style: fieldInputStyle }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "jkc-radio-section", style: settings.isRadioDisplayFlex ? flexStyle : gridStyle }, { children: settings.json.map((element, i) => {
                        return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "samrtjkcradiobutton", style: { display: "flex", alignItems: "center" } }, { children: [(0, jsx_runtime_1.jsx)("input", { type: "radio", className: settings.className, name: name, style: radioInputStyle, onChange: onChangeEvent, checked: settings.value === element.value, value: element.value, id: element.value }), (0, jsx_runtime_1.jsx)("label", Object.assign({ style: Object.assign(Object.assign({}, radioLabelStyle), settings.radioLabelStyle), htmlFor: element.value }, { children: element.name }))] }), i));
                    }) })) }))] })));
};
exports.default = JkcRadio;
